export default function FormatDate({ date = null } = {}) {
  const d = date.split('-');
  //console.log(d);
  const newDate = `${d[2]}/${d[1]}/${d[0]}`;
  return newDate;
}
